module.exports = __webpack_public_path__ + "img/jingbeihao.d0289dc0.png";